module.exports = __webpack_public_path__ + "static/media/calpro_logo.e695268a.png";